import PaginatedListState from 'flarum/common/states/PaginatedListState';
export default class BirthdayListState extends PaginatedListState {
  static UPCOMING_DAYS = 7;
  constructor() {
    super({});
  }
  get type() {
    return 'users';
  }
  requestParams() {
    const today = dayjs();
    const until = today.add(BirthdayListState.UPCOMING_DAYS, 'day');
    return {
      filter: {
        birthday: `${today.format('YYYY-MM-DD')}..${until.format('YYYY-MM-DD')}`
      }
    };
  }
}
flarum.reg.add('datlechin-birthdays', 'forum/states/BirthdayListState', BirthdayListState);